export const BUSINESS_PROFILING_BANNER_BLURB = `Let us get to know you and your needs better. \n Discover the right solution for your business needs.`;
export const BUSINESS_PROFILING_NSO_REFERENCE = `Based on NSO, Employment Level Range and BSP's Asset Size Range in Philippine Peso <br/>Source: SMED Council Resolution No. 1 (2003); Republic Act 9501 (2008)`;
export const BUSINESS_PROFILING_THANK_YOU_MESSAGE = `We look forward to becoming your partner in growing your business. <br/><br/> Here's a recap of the information you provided. Kindly expect an EastWestbanker to get in touch with you at your requested schedule.`;
export const BUSINESS_INFORMATION_DISCLAIMER = `(Disclaimer: This form is used for the purpose of providing more information on the Bank's products and services. For after-sales inquiries, feedback, and other banking concerns, please call the EastWest 24-Hour Customer Service at +63288881700 or visit at <a href="/contactus" target="__blank">www.eastwestbanker.com/contactus</a>)`;
export const CASH_MANAGEMENT = "CASH MANAGEMENT";
export const COMPARE_UITF_PRODUCTS =
  "Compare our UITF products and choose the right option for you";
export const CONTACT_US = "CONTACT US";
export const CONTACT_NUMBER = "Contact Number";
export const CREDIT_CARDS = "Credit Cards";
export const CREDIT_CARD_HEADER_BLURB =
  "Let us help you find the best credit card that fits your lifestyle.";

export const DO_YOU_HAVE_AN_EXISTING_EASTWEST_ACCOUNT =
  "Do you have an existing EastWest account?";
export const DOWNLOAD_APP = "DOWNLOAD APP";
export const DEPOSIT = "DEPOSIT";
export const DEPOSIT_A_CHECK = "DEPOSIT A CHECK";

export const EASTWEST_UITF_FEATURES = "EastWest UITF Features";
export const EASTWEST_UITF_PRODUCTS = "EastWest UITF Products";
export const EASTWEST_UITF_FEES = "EastWest UITF Fees";
export const EMAIL = "Email";

export const ABSOLUTE_RETURN = "Absolute Return on Investment";
export const ADDRESS_SUBTEXT =
  "House No., Lot./Blk No., Street, Bgy/Subdivision, Province/City, Zip Code, Country";
export const AMOUNT_CONTRIBUTION = "Amount of Contribution";
export const CURRENT_MARKET_VALUE = "Current Market Value";
export const END_DATE_NAVPU = "End/Redemption Date NAVPU";
export const END_INVESTEMENT = "End of Investment";
export const INVESTMENT_PERFORMANCE_CALCULATOR =
  "Investment Performance Calculator";
export const INVESTMENT_PRODUCT = "Investment Product";
export const NUMBER_OF_UNITS = "Number of Units";
export const START_DATE_NAVPU = "Start Date NAVPU";
export const START_INVESTMENT = "Start of Investment";

export const FIXED_INCOME_PRODUCTS = "Fixed Income Products";
export const FOR_FURTHER_QUERIES =
  "For further queries, please feel free to visit any EastWest Store or call EastWest SEDEX Office: 8575-3888 local 8684 and 3770";
export const FOR_OTHER_INQUIRIES =
  "For other inquiries or concerns, you may call EastWest 24-Hour Customer Service at <a href='tel:+63288881700'>+63288881700</a> or e-mail us at <a href='mailto:service@eastwestbanker.com'>service@eastwestbanker.com</a>";

export const HELP_AND_SUPPORT = "Help And Support";
export const HERE_ARE_WAYS_WE_CAN_HELP = "Here are ways we can help";
export const HIDE_PRODUCT_FEATURES = "HIDE PRODUCT FEATURES";

export const INVESTMENT = "Investment";

export const JUMPSTART_YOUR_FINANCIAL_JOURNEY =
  "Jumpstart your financial journey with the right banking solutions.";

export const LEARN_MORE = "LEARN MORE";
export const LIST_OF_ACCEPTED_IDs = "List of Accepted IDs";

export const MAXIMUM_OF_THREE_STATEMENTS_WARNING =
  "Please choose only up to three (3) statements that most apply to you.";

export const NAME = "Name";
export const NAVPU_TITLE = "NAVPU (Net Asset Value Per Unit)";

export const OUR_TRUST_PRODUCTS_AND_SERVICES =
  "OUR TRUST PRODUCTS AND SERVICES";
export const OUR_FIXED_INCOME_PRODUCTS = "OUR FIXED INCOME PRODUCTS";

export const OUR_SERVICES_RECOMMENDED_FOR_YOU =
  "OUR SERVICES RECOMMENDED FOR YOU";

export const PLEASE_CALL_FOR_FIRM_OFFER_RATES =
  "Note: Please call for firm offer rates/price. Rates are subject to taxes and fees.";

export const PLEASE_CHOOSE_YOUR_PREFERRED_STORE =
  "Please Choose Your Preferred Store.";
export const PLEASE_CHOOSE_YOUR_PREFERRED_TIME_OF_THE_DAY =
  "Please Choose Your Preferred Time of the Day.";
export const PLEASE_SELECT_AT_LEAST_ONE_ITEM =
  "Please select at least one item.";
export const PREFERRED_DAY = "Preferred Time";
export const PREFERRED_STORE = "Preferred Store";
export const PREPARE_THE_CHECK_FOR_DIGITAL_DEPOSIT =
  "Prepare The Check For Digital Deposit";
export const PRIVACY_POLICY = "Privacy Policy";
export const PRIVACY_STATEMENT = "Privacy Statement";
export const PRODUCT_FEATURES = "Product Features";
export const PRODUCTS_COMPARISON = "PRODUCTS COMPARISON";

export const REQUIREMENTS = "REQUIREMENTS";
export const REQUEST_FOR_CALLBACK = "REQUEST FOR CALLBACK";
export const REQUEST_FOR_CALLBACK_BLURB =
  "Find out how our products and services can bring you closer to achieving your goals. Share your contact details and let’s talk.";
export const REQUEST_FOR_CALLBACK_DISCLAIMER =
  "Disclaimer: This form is used for the purpose of providing more information on the Bank's products and services to inquiring customers. For after-sales inquiries, feedback, and other banking concerns, please call the EastWest 24-Hour Customer Service at <a href='tel:+63288881700'>+63288881700</a>  or visit <a href='https://www.eastwestbanker.com/contactus'> https://www.eastwestbanker.com/contactus</a>";
export const RESIDENCE_OR_BUSINESS_ADDRESS = "Residence or Business Address";
export const REVIEW_FORM_INSTRUCTION =
  "Please review the information provided before clicking ‘Submit’.";

export const SHOW_LESS = "SHOW LESS";
export const SHOW_PRODUCT_FEATURES = "SHOW PRODUCT FEATURES";
export const SOMETHING_WENT_WRONG_PLEASE_TRY_AGAIN_LATER =
  "Something Went Wrong. Please try again later.";
export const SUBMIT = "Submit";
export const TERMS_OF_USE = "Terms of Use";
export const TOOLS_AND_RESOURCES = "TOOLS AND RESOURCES ";
export const TOP_5_BOND_PICKS = "TOP BOND PICKS";
export const TRACE_MOBILE_CHECK = "TRACE MOBILE CHECK";

export const UITF_BANNER_BLURB =
  "Let our professional fund managers take care of your holdings especially if you’re just starting your investment journey or don’t have the time to monitor the market";
export const UITF_DISCLAIMER =
  "Unit Investment Trust Funds are not deposit products and are not obligations of, or guaranteed, or issued by East West Banking Corporation or its affiliates or subsidiaries. It is not insured by the Philippine Deposit Insurance Corporation (PDIC). Due to the nature of the investments, yields and potential yields cannot be guaranteed. Any income or loss arising from market fluctuations and price volatility of the investments held by the UITFs, even if invested in government securities, is for the account of the investor. As such, units of participation of the investor in the UITFs, when redeemed, may be worth more or be worth less than the client's initial investment. The Trustee is not liable for losses unless upon willful default, bad faith or gross negligence. Prior to admission to the Fund, the Trustee is required to perform client profiling process through the client suitability test or Investor Risk Profiling Questionnaire to guide the client in choosing the UITF which is suited to his objectives, risk profile, investment horizon and experience. Investors are advised to read the Funds Declarations of Trust before investing, which is available from the office of the Trustee.";

export const UITF_PRODUCTS_HEADER = "OUR UNIT INVESTMENT TRUST FUND PRODUCTS";

export const UITF_TITLE = "Unit Investment Trust Fund";
export const USTD_PROMO = "USD TD 4.5% NTB Promo";
export const VISIT_ANY_EASTWEST_STORE_TO_START_INVESTING =
  "Visit any EastWest Store to start investing.";

export const KRISFLYER_MASTERCARD =
  " EastWest Singapore Airlines KrisFlyer World Mastercard";
